import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useAccCurrencyRate, AccCurrencyRate } from './useData';
import { moduleConfig, getDetailSections } from './config';

export { List } from './List';
export { Form } from './Form';

export const Detail: React.FC = () => (
  <GenericDetailPage<AccCurrencyRate>
    useData={useAccCurrencyRate}
    config={{ ...moduleConfig, getDetailSections }}
  />
);
